import React from 'react';

import Img from '@common/Image';

const RebrandFixedImages = ({ data }) => {
  const {
    images
  } = data;
  return (
    <>
      {images && images.map((image, index) => (
        <Img
          key={index}
          image={image.gatsbyImageData}
          file={image.file}
          className='d-none d-xl-block'
          imgStyle={{
            position: 'absolute',
            top: `${image.title}`,
            [image?.description.toLowerCase()]: 0,
            zIndex: -1
          }}
        />
      ))}
    </>
  )
}

export default RebrandFixedImages
